import { FunctionComponent } from "react";

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    styled,
} from "@mui/material";

import { useRefinementList } from "react-instantsearch";

import { FreebieRuleTypeNames, freebieRuleStatusNames } from "../../utils/enums";

const StyledDialogContent = styled(DialogContent)`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(2)};
    min-width: 400px;
`;

export interface IFilterDialogProps {
    open: boolean;
    onClose: () => void;
}

export const FilterDialog: FunctionComponent<IFilterDialogProps> = (
    props: IFilterDialogProps,
) => {
    const { open, onClose } = props;

    const statusRefinement = useRefinementList({ attribute: "status" });
    const typeRefinement = useRefinementList({ attribute: "type" });

    const selectedStatus =
        statusRefinement.items.find((item) => item.isRefined)?.value ?? "";
    const selectedType =
        typeRefinement.items.find((item) => item.isRefined)?.value ?? "";

    const handleStatusChange = (event: SelectChangeEvent) => {
        if (selectedStatus) {
            statusRefinement.refine(selectedStatus);
        }
        if (event.target.value) {
            statusRefinement.refine(event.target.value);
        }
    };

    const handleTypeChange = (event: SelectChangeEvent) => {
        if (selectedType) {
            typeRefinement.refine(selectedType);
        }
        if (event.target.value) {
            typeRefinement.refine(event.target.value);
        }
    };

    const handleClear = () => {
        if (selectedStatus) statusRefinement.refine(selectedStatus);
        if (selectedType) typeRefinement.refine(selectedType);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Filter</DialogTitle>
            <StyledDialogContent>
                <FormControl fullWidth size="small">
                    <InputLabel>Status</InputLabel>
                    <Select
                        value={selectedStatus}
                        label="Status"
                        onChange={handleStatusChange}>
                        <MenuItem value="">All</MenuItem>
                        {Object.entries(freebieRuleStatusNames).map(
                            ([key, value]) => (
                                <MenuItem key={key} value={key}>
                                    {value}
                                </MenuItem>
                            ),
                        )}
                    </Select>
                </FormControl>

                <FormControl fullWidth size="small">
                    <InputLabel>Type</InputLabel>
                    <Select
                        value={selectedType}
                        label="Type"
                        onChange={handleTypeChange}>
                        <MenuItem value="">All</MenuItem>
                        {Object.entries(FreebieRuleTypeNames).map(
                            ([key, value]) => (
                                <MenuItem key={key} value={key}>
                                    {value}
                                </MenuItem>
                            ),
                        )}
                    </Select>
                </FormControl>
            </StyledDialogContent>
            <DialogActions>
                <Button onClick={handleClear}>Clear</Button>
                <Button onClick={onClose} variant="contained">
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    );
};
